import { QuestionnaireResultStatus } from "@/types/questionnaries";

export const mapQuestionnaireResultStatusToLabel = (
  value: QuestionnaireResultStatus,
) => {
  switch (value) {
    case "APPROVED":
      return "Aprobado";
    case "FAILED":
      return "No aprobado";
    case "NOT_EVALUATED":
      return "No evaluado";
  }
};
